import { render, staticRenderFns } from "./BusinessOpportunity.vue?vue&type=template&id=edb1eb3e&scoped=true"
import script from "./BusinessOpportunity.vue?vue&type=script&lang=js"
export * from "./BusinessOpportunity.vue?vue&type=script&lang=js"
import style0 from "./BusinessOpportunity.vue?vue&type=style&index=0&id=edb1eb3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb1eb3e",
  null
  
)

export default component.exports